import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FP020 {
  fp020_01: string;        // 瑕疵因代號 (PK, max 4 chars)
  fp020_11: string;        // 中文名稱
  fp020_12: number;        // (保留欄位)
  fp020_13: string;        // 英文名稱
  fp020_91: string;        // 建立者
  fp020_92: string | null; // 建立/修改日期
  fp020_93: string;        // 修改者
}

export interface CreateRequest {
  fp020_01: string;
  fp020_11: string;
  fp020_13: string;
}

export interface UpdateRequest {
  fp020_01: string;
  fp020_11: string;
  fp020_13: string;
}

export interface ListResponse {
  data: FP020[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const defectCauseApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/defect-cause', { params });
    return res.data;
  },

  async get(code: string): Promise<FP020> {
    const res = await apiClient.get(`/api/defect-cause/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FP020> {
    const res = await apiClient.post('/api/defect-cause', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FP020> {
    const res = await apiClient.put(`/api/defect-cause/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/defect-cause/${encodeURIComponent(code)}`);
  },
};
